import axios from "axios";
import { decrypt } from "../util/rotinas";
import { toast } from 'react-toastify';

let api;
let token = localStorage.getItem("@ipm:token") ? decrypt(localStorage.getItem("@ipm:token"), false) : null;
if (token) {
  api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:3334",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
} else {
  api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:3334",
    // baseURL: process.env.REACT_APP_API_URL || "http://177.44.191.62:3334/",
  });
}

api.interceptors.response.use(
  (response) => {
    if (
      response.status === 401 ||
      response.data.message === "401 Unauthorized"
    ) {
      toast.error(`${response.data.message}`, {
        position: "bottom-center",
        autoClose: true,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: 0,
      });
    }
    return response;
  },
  (error) => {
    if (error.response.status === 403) {
      localStorage.removeItem("@ipm:token");
      localStorage.removeItem("@ipm:usuario");
      localStorage.removeItem("@ipm:logged");
      window.location = "/";

      return Promise.reject(error.response.data);
    }

    toast.error(`${error.response.data.message}`, {
      position: "bottom-center",
      autoClose: true,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: 0,
    });

    return Promise.reject(error.message);
  }
);

export default api
